<div id="pano" style="width: 500px !important; height: 300px !important;"></div>